<div
  tabindex="0"
  class="comments-fade comments-container {{ commentsActive ? 'show' : '' }}">
  <div
    class="comments-title text-center d-flex align-items-center justify-content-between">
    <div class="ps-0 text-start"></div>
    <div>Comments</div>
    <div class="text-end pe-0">
      <i
        (click)="toggleComments()"
        title="hide-icon"
        role="button"
        class="bi bi-arrow-bar-right me-2 p-2"></i>
    </div>
  </div>
  <div class="comments-input">
    <div class="input-group datepicker-popup">
      <label for="leaveComment" class="visually-hidden">Leave a Comment</label>
      <input
        labelForId="leaveComment"
        class="form-control rounded-start"
        type="text"
        placeholder="Leave a comment"
        aria-label="Leave a comment"
        (keydown.enter)="saveComment()"
        [(ngModel)]="newComment.comment" />
      <button
        aria-label="Save comment"
        class="btn btn-primary"
        (click)="saveComment()"
        type="button">
        Comment
      </button>
    </div>
  </div>
  <div class="comments-body">
    <app-comments
      [commentList]="commentList"
      [hideCommentSubmissonInput]="true"
      (commentDeleted)="getComments()"
      [refTable]="'egrowe_coachlog'"
      [refTableId]="sessionId" />
  </div>
</div>
